import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import {
    SuperAdminRentChargeDetailDto,
    SuperAdminRentChargeListItemDto,
} from '@/features/superAdmin/features/data/types/superAdmin-data.types';

type LocationState = {
    rentCharge?: SuperAdminRentChargeListItemDto;
};

export const useSuperAdminRentChargeDetailApi = (id?: string) => {
    const axiosInstance = useAxiosAuth();
    const location = useLocation();
    const locationState = location.state as LocationState | null;
    const stateRentCharge = locationState?.rentCharge;
    const placeholderRentCharge =
        stateRentCharge?.id === id ? ({ ...stateRentCharge, infos: [] } as SuperAdminRentChargeDetailDto) : undefined;

    const { data, isLoading, error } = useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.rentCharges.queryKeys.detail, id],
        enabled: Boolean(id),
        placeholderData: placeholderRentCharge,
        queryFn: async (): Promise<SuperAdminRentChargeDetailDto> => {
            const response = await axiosInstance.get<SuperAdminRentChargeDetailDto>(
                `${ApiConfig.queries.superAdmin.data.rentCharges.endpoints.detail}/${id}`,
            );
            return response.data;
        },
    });

    return {
        rentCharge: data,
        isLoading,
        error,
    };
};
